// test1287
(1287 && 0);
